// material-ui
import { Button, CardMedia, Link, Stack, Typography } from "@mui/material";
import { Call, DirectInbox } from "iconsax-react";

import AnimateButton from "components/@extended/AnimateButton";
// project-imports
import MainCard from "components/MainCard";
// assets
import avatar from "assets/images/users/customer-support-1.png";

// ==============================|| DRAWER CONTENT - NAV CARD ||============================== //

const NavCard = () => (
  <MainCard sx={{ bgcolor: "secondary.lighter", m: 3 }}>
    <Stack alignItems="center" spacing={2.5}>
      <CardMedia component="img" image={avatar} />
      <Stack alignItems="center">
        <Typography variant="h5">Need Support?</Typography>
        <Stack direction="row" alignItems="center" spacing={2} mt={2}>
          <Call size={15} />
          <Typography variant="h6" href="tel: 0553019529" target="_blank">
            055 280 9558
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Call size={15} />
          <Typography variant="h6" href="tel: 0553019529" target="_blank">
            055 301 9529
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={2}>
          <DirectInbox size={15} />
          <Typography variant="h6" component={Link} href="support@wigal.com.gh" target="_blank">
            support@wigal.com.gh
          </Typography>
        </Stack>
      </Stack>
      <AnimateButton>
        <Button variant="shadow" size="small" component={Link} href="https://support.wigal.com.gh/" target="_blank">
          Get Support
        </Button>
      </AnimateButton>
    </Stack>
  </MainCard>
);

export default NavCard;
